import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  MasterLocationsGlobalState,
  MasterLocationsGlobalStateModel,
} from '../../../state/master-locations-global.state';

@Injectable({providedIn: 'root'})
export class HttpTenantInterceptor implements HttpInterceptor {
    
  constructor(private store: Store) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const tenantId = this.store.selectSnapshot(MasterLocationsGlobalState.TenantId)
    
    const request = req.clone({
      setHeaders: {
        tenantId: tenantId ?? '',
      },
    });

    return next.handle(request);
  }
}
